import { render, staticRenderFns } from "./TenantTypeManager.vue?vue&type=template&id=3ec4ae38&scoped=true&"
import script from "./TenantTypeManager.vue?vue&type=script&lang=js&"
export * from "./TenantTypeManager.vue?vue&type=script&lang=js&"
import style0 from "./TenantTypeManager.vue?vue&type=style&index=0&id=3ec4ae38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec4ae38",
  null
  
)

export default component.exports